import request from '@/config/axios'
export interface LiveRoomVO {
  id?: number
  title: string
  coverUrl?: string
  description?: string
  anchorUserId?: number
  /** 主播账号展示文案 */
  anchorAccount?: string
  anchorNickname?: string
  anchorMobile?: string
  anchorId?: number
  anchorStatus?: number
  livePermissionLabel?: string
  livePermissionEnabled?: boolean
  livePermissionToggleable?: boolean
  anchorRealName?: string
  idCardFront?: string
  idCardBack?: string
  sourceType: number
  status?: number
  auditStatus?: number
  visibility?: number
  externalUrl?: string
  scheduledStartTime?: string
  recordingEnabled?: boolean
  replayEnabled?: boolean
  chatEnabled?: boolean
  likeEnabled?: boolean
  shareEnabled?: boolean
  recommended?: boolean
  recommendSort?: number
  /** 本场优惠券模板 ID，逗号分隔 */
  voucherIds?: string
  totalViewCount?: number
  totalLikeCount?: number
  createTime?: string
}
export const getRoomPage = (params: any) => request.get({ url: '/live/room/page', params })
export const getRoom = (id: number) => request.get({ url: '/live/room/get', params: { id } })
export const createRoom = (data: LiveRoomVO) => request.post({ url: '/live/room/create', data })
export const updateRoom = (data: LiveRoomVO) => request.put({ url: '/live/room/update', data })
export const deleteRoom = (id: number) =>
  request.delete({ url: '/live/room/delete', params: { id } })
export const submitAudit = (id: number) =>
  request.post({ url: '/live/room/submit-audit', params: { id } })
export const auditRoom = (id: number, pass: boolean) =>
  request.post({ url: '/live/room/audit', params: { id, pass } })
export const startRoom = (id: number) => request.post({ url: '/live/room/start', params: { id } })
export const stopRoom = (id: number) => request.post({ url: '/live/room/stop', params: { id } })
export const cancelRoom = (id: number) => request.post({ url: '/live/room/cancel', params: { id } })
